import { supabase } from "@/integrations/supabase/client";
import { toolCategories } from "@/data/tools";

const SESSION_KEY = "taskeer_tool_session";

export const getSessionId = (): string => {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return "anon";
  }
};

export interface ToolRef {
  slug: string;
  categoryId: string;
  title: string;
  categoryLabel: string;
}

const toolIndex: Record<string, ToolRef> = {};
for (const category of toolCategories) {
  for (const tool of category.tools) {
    const slug = tool.to.replace("/ferramentas/", "").replace(/^\//, "");
    toolIndex[slug] = {
      slug,
      categoryId: category.id,
      title: tool.title,
      categoryLabel: category.label,
    };
  }
}

export const toolRegistry = toolIndex;

export const getToolByPath = (pathname: string): ToolRef | null => {
  if (!pathname.startsWith("/ferramentas/")) return null;
  const slug = pathname.replace("/ferramentas/", "").replace(/\/$/, "");
  return toolIndex[slug] ?? null;
};

/** Envia um evento de engajamento da ferramenta (nunca quebra a UI). */
export const trackToolEvent = async (
  tool: ToolRef,
  eventType: "view" | "use",
) => {
  try {
    await supabase.from("tool_events").insert({
      tool_slug: tool.slug,
      category_id: tool.categoryId,
      event_type: eventType,
      session_id: getSessionId(),
      referrer: typeof document !== "undefined" ? document.referrer.slice(0, 500) || null : null,
      path: typeof window !== "undefined" ? window.location.pathname.slice(0, 300) : null,
    });
  } catch {
    // silencioso: métricas nunca podem afetar a experiência
  }
};
